import { ValueTypeEnum } from './value-type-enum.model';
import { FormElementType } from './form-element-type.model';
import { FormField } from './form-field.model';

export class FormElement {
  public constructor() {
    this.intialize();
  }

  public intialize = (): void => {
    this.Id = 0;
    this.Guid = '';
    this.LabelText = '';
    this.HelpText = '';
    this.Text = '';
    this.ValueType = ValueTypeEnum.none;
    this.ElementTypeId = 0;
    this.Order = 0;
    this.EditMode = false;
    this.Field = new FormField();
    this.Required = false;
  };

  public Id: number;
  public Guid: string;
  public LabelText: string;
  public HelpText: string;
  public Value: any;
  public ValueType: ValueTypeEnum;
  public ElementTypeId: number;
  public Order: number;
  public EditMode: boolean;
  public Field: FormField;
  public Required: boolean;
  public Text: string;
}
